 
        <a href="javascript:;" (click) = "goBack()" class="headerButton">
        
           <ion-icon name="arrow-back"></ion-icon>
            <!-- <i class="fa fa-arrow-left" aria-hidden="true"></i> -->
        </a> 
    
    
